import React, { ReactElement, useEffect } from 'react';
import { RegisterWrapper } from '../../features/auth/RegisterWrapper';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';
import { RegisterStep } from '../../../infrastructure/types/features/auth/auth-types';
import { maskingHandlers } from '../../../../shared/infrastructure/masking-helpers/masking-handlers';

interface ContentProps {
  phone?: string;
}

function Content({ phone }: ContentProps): ReactElement {
  const { authorizationUiModule } = useUILogic();
  const coreManager = authorizationUiModule.registerUIManager.coreManager;

  useEffect(() => {
    if (phone) {
      const { updatedUnmaskedValue } = maskingHandlers.phoneNumberMask({ value: phone });
      if (updatedUnmaskedValue) {
        coreManager.setPhone(updatedUnmaskedValue as PhoneNumber);
        coreManager.setStep(RegisterStep.ENTER_PHONE);
      }
    }
  }, [phone]);

  return <RegisterWrapper />;
}

export { Content };
